// FILE: src/pages/ClientPortal/ClientCaregivers.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { clientPortalAPI } from '../../api/services';
import { toast } from 'react-toastify';
import './ClientPortal.css';

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}) : '—';
const colors  = ['#1a4d8c','#059669','#d97706','#7c3aed','#db2777','#0891b2'];
const initials = (name='') => name.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2);

export default function ClientCaregivers() {
  const [caregivers, setCaregivers] = useState([]);
  const [loading,    setLoading]    = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await clientPortalAPI.getCaregivers();
      setCaregivers(res.data.data || []);
    } catch { toast.error('Failed to load caregivers.'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="cp-page">
      <div className="cp-header">
        <h1 className="cp-title">My Caregivers</h1>
        <p className="cp-subtitle">Caregivers who have been assigned to your care</p>
      </div>

      {loading ? <p style={{color:'#6b7280'}}>Loading caregivers…</p>
       : caregivers.length === 0
       ? <div className="cp-empty"><div className="cp-empty-icon">👤</div><div className="cp-empty-text">No caregivers assigned yet</div></div>
       : caregivers.map((c, i) => (
          <div key={c.UserID||i} className="cp-caregiver-card">
            <div className="cp-avatar" style={{ backgroundColor: colors[i % colors.length] }}>
              {initials(c.FullName)}
            </div>
            <div style={{ flex: 1 }}>
              <div className="cp-caregiver-name">{c.FullName}</div>
              {c.Specialty && <div className="cp-caregiver-specialty">🏥 {c.Specialty}</div>}
              {c.YearsOfExperience && <div className="cp-caregiver-specialty">⭐ {c.YearsOfExperience} years experience</div>}
              <div className="cp-caregiver-stats">
                {c.TotalVisits} visit{c.TotalVisits !== 1 ? 's' : ''} · Last: {fmtDate(c.LastVisit)}
              </div>
              {c.ServiceName && <div className="cp-caregiver-specialty" style={{color:'#3b82f6'}}>🩺 {c.ServiceName}</div>}
            </div>
            {c.PhoneNumber && (
              <div style={{ textAlign:'right' }}>
                <a href={`tel:${c.PhoneNumber}`} style={{ color:'#1a4d8c', fontSize:13, textDecoration:'none', fontWeight:600 }}>
                  📞 Call
                </a>
              </div>
            )}
          </div>
        ))
      }
    </div>
  );
}
